import React from 'react';

import Col1_Img_1 from '../../../Images/gallery/gire/col-1_img-1.png';
import Col1_Img_2 from '../../../Images/gallery/gire/col-1_img-2.png';
import Col1_Img_3 from '../../../Images/gallery/gire/col-1_img-3.png';
import Col1_Img_4 from '../../../Images/gallery/gire/col-1_img-4.png';
import Col1_Img_5 from '../../../Images/gallery/gire/col-1_img-5.png';
import Col1_Img_6 from '../../../Images/gallery/gire/col-1_img-6.png';
import Col1_Img_7 from '../../../Images/gallery/gire/col-1_img-7.png';
import Col1_Img_8 from '../../../Images/gallery/gire/col-1_img-8.png';

import Col2_Img_1 from '../../../Images/gallery/gire/col-2_img-1.png';
import Col2_Img_2 from '../../../Images/gallery/gire/col-2_img-2.png';
import Col2_Img_3 from '../../../Images/gallery/gire/col-2_img-3.png';
import Col2_Img_4 from '../../../Images/gallery/gire/col-2_img-4.png';
import Col2_Img_5 from '../../../Images/gallery/gire/col-2_img-5.png';
import Col2_Img_6 from '../../../Images/gallery/gire/col-2_img-6.png';
import Col2_Img_7 from '../../../Images/gallery/gire/col-2_img-7.png';

import Col3_Img_1 from '../../../Images/gallery/gire/col-3_img-1.png';
import Col3_Img_2 from '../../../Images/gallery/gire/col-3_img-2.png';
import Col3_Img_3 from '../../../Images/gallery/gire/col-3_img-3.png';
import Col3_Img_4 from '../../../Images/gallery/gire/col-3_img-4.png';
import Col3_Img_5 from '../../../Images/gallery/gire/col-3_img-5.png';
import Col3_Img_6 from '../../../Images/gallery/gire/col-3_img-6.png';
import Col3_Img_7 from '../../../Images/gallery/gire/col-3_img-7.png';
import Col3_Img_8 from '../../../Images/gallery/gire/col-3_img-8.png';

export const Gire_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>GIRE</span>,
  },
];

export const Title_Video = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>YO NO CIERRO LOS OJOS</span>,
  },
];

export const Title_Video_2 = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>ONE-MINUTE FILM</span>,
  },
];

export const Title_3 = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>PHOTOGRAPHY</span>,
  },
];

export const Col_1 = [
  {
    src: Col1_Img_1,
    alt: 'Luis Gerardo Mendez',
  },
  {
    src: Col1_Img_2,
    alt: 'Cecilia Suarez',
  },
  {
    src: Col1_Img_3,
    alt: 'Paola Rojas',
  },
  {
    src: Col1_Img_4,
    alt: 'Gabriela',
  },
  {
    src: Col1_Img_5,
    alt: 'Ana Francisca',
  },
  {
    src: Col1_Img_6,
    alt: 'Tiare',
  },
  {
    src: Col1_Img_7,
    alt: 'Apio',
  },
  {
    src: Col1_Img_8,
    alt: 'Dani Magun',
  },
];

export const Col_2 = [
  {
    src: Col2_Img_1,
    alt: 'Adela Micha',
  },
  {
    src: Col2_Img_2,
    alt: 'Diego Luna',
  },
  {
    src: Col2_Img_3,
    alt: 'Jose Maria Yazpik',
  },
  {
    src: Col2_Img_4,
    alt: 'Claudia Lizaldi',
  },
  {
    src: Col2_Img_5,
    alt: 'Meme',
  },
  {
    src: Col2_Img_6,
    alt: 'Leticia Roman',
  },
  {
    src: Col2_Img_7,
    alt: 'Diana Bovio',
  },
];

export const Col_3 = [
  {
    src: Col3_Img_1,
    alt: 'Dolores',
  },
  {
    src: Col3_Img_2,
    alt: 'Carlos Puig',
  },
  {
    src: Col3_Img_3,
    alt: 'Maria Jose',
  },
  {
    src: Col3_Img_4,
    alt: 'Luis',
  },
  {
    src: Col3_Img_5,
    alt: 'Marion',
  },
  {
    src: Col3_Img_6,
    alt: 'Johanna Murillo',
  },
  {
    src: Col3_Img_7,
    alt: 'Andres',
  },
  {
    src: Col3_Img_8,
    alt: 'Monica',
  },
];
